export { default as BlackText } from './BlackText';
export { default as GrayText } from './GrayText';
export { default as GreenText } from './GreenText';
export { default as LightText } from './LightText';
export { default as PrimaryText } from './PrimaryText';
export { default as SecondaryText } from './SecondaryText';
export { default as WhiteText } from './WhiteText';
export { default as YellowText } from './YellowText';
export { default as ErrorText } from './ErrorText';